export default class FrontPageEnum {
    static STRATE_SOCIAL_WALL = '[data-element="social-wall"]'
}
